import React, { useEffect, useRef } from 'react';
export function FloatingVideo() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const freezePoint = 2.5; // seconds
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const handleTimeUpdate = () => {
      if (video.currentTime >= freezePoint) {
        video.pause();
      }
    };
    let scrollTimeout: NodeJS.Timeout;
    const handleScroll = () => {
      if (video.paused && video.currentTime >= freezePoint) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        // Scroll ended
      }, 150);
    };
    // Throttled scroll listener to prevent constant resetting during a single scroll motion
    let isScrolling = false;
    const throttledScroll = () => {
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          if (video.paused && video.currentTime >= freezePoint) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
          isScrolling = false;
        });
        isScrolling = true;
      }
    };
    video.addEventListener('timeupdate', handleTimeUpdate);
    window.addEventListener('scroll', throttledScroll, {
      passive: true
    });
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      window.removeEventListener('scroll', throttledScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);
  return <div className="fixed bottom-6 right-6 z-50 w-48 h-64 rounded-2xl overflow-hidden shadow-2xl border-2 border-brand-gold/30 bg-gray-900" data-id="element-127">
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/tc43JBsfauMeVoy1hqDxMi/_users_b7ec7ded-f26a-48dc-a3da-3ee6bd3d5528_generated_a6533b96-aac7-42dd-91d6-9ea055225b1e_generated_video.mp4" autoPlay muted playsInline className="w-full h-full object-cover" data-id="element-128" />
    </div>;
}